import request from '@/utils/request';
import FileSaver from 'file-saver';
import * as RESULT_CODE from '@/constant/system/result-code';
import { toast } from './message';

/**
 * HTTP工具
 * @author Jay Qing
 * @since 2020/11/25
 */

/**
 * 下载文件
 *
 * @param url 地址
 * @param params 请求参数
 */
export function download(url: string, params?: any) {
  return request({
    url: url,
    method: 'get',
    params: params,
    responseType: 'blob',
    timeout: 6 * 60 * 1000
  }).then(result => {
    handleDownload(result);
  });
}

/**
 * 处理下载结果
 *
 * @param result 下载结果
 */
export function handleDownload(result: any) {
  if (result.data.type === 'application/octet-stream') {
    downloadOctetStream(result)
    return;
  }

  if (result.data.type === 'application/json') {
    const reader = new FileReader();
    reader.onload = (ev: any) => {
      if (ev.target.readyState === 2) {
        const result = JSON.parse(ev.target.result);
        if (!result) {
          toast.error('文件下载出错')
          console.error(result);
          return;
        }
        if (result.code === RESULT_CODE.OK) {
          toast.success(result.message)
        } else {
          toast.error(result.message)
        }
      }
    };
    reader.readAsText(result.data);
    return;
  }
  FileSaver.saveAs(
    result.data,
    decodeURIComponent(result.headers.filename || 'document')
  );
}

function downloadOctetStream(result: any) {
  const blob = new Blob([result.data])
  const fileName = result.headers['content-disposition']?.match(/=(.*)$/)[1] || 'document'

  if ('download' in document.createElement('a')) { // 非IE下载
    const elink = document.createElement('a');//创建一个a标签通过a标签的点击事件区下载文件
    elink.download = decodeURIComponent(fileName);
    elink.style.display = 'none';
    elink.href = URL.createObjectURL(blob);//使用blob创建一个指向类型数组的URL
    document.body.appendChild(elink);
    elink.click();
    URL.revokeObjectURL(elink.href); // 释放URL 对象
    document.body.removeChild(elink);
  } else { // IE10+下载
    FileSaver.saveAs(
      result.data,
      decodeURIComponent(fileName || 'document')
    );
  }
}


/**
 * 上传文件
 *
 * @param url 上传地址
 * @param data 表单数据
 */
export function upload(url: string, data: any) {
  return request({
    url: url,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data,
    // errorMessage: false,
    timeout: 2 * 60 * 1000,
  });
}
